import React from "react";
import CircularLoader from "../components/Portal/universal_components/CircularLoader/CircularLoader";

const NoNexusFound = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100vw",
        height: "100vh",
      }}
    >
      <p>No Nexus Found</p>
    </div>
  );
};

export default NoNexusFound;
